<h2 mat-dialog-title class="detail-title">
  {{ 'DEAD_LETTERS.DETAIL.TITLE' | translate }}
</h2>

<div mat-dialog-content class="detail-content">
  <div class="detail-header">
    <div class="detail-id-block">
      <div class="detail-id-label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.ID' | translate }}</div>
      <div class="detail-id-value value-copyable">{{ deadLetterId }}</div>
    </div>

    <div class="detail-actions">
      <button
        mat-icon-button
        type="button"
        [disabled]="!detail"
        (click)="resubmit()"
        [matTooltip]="'DEAD_LETTERS.DETAIL.ACTIONS.RESUBMIT' | translate"
        [attr.aria-label]="'DEAD_LETTERS.DETAIL.ACTIONS.RESUBMIT' | translate">
        <mat-icon>replay</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        [disabled]="!detail"
        (click)="delete()"
        [matTooltip]="'DEAD_LETTERS.DETAIL.ACTIONS.DELETE' | translate"
        [attr.aria-label]="'DEAD_LETTERS.DETAIL.ACTIONS.DELETE' | translate">
        <mat-icon>delete</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="close()"
        [attr.aria-label]="'DEAD_LETTERS.DETAIL.ACTIONS.CLOSE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  @if (detailLoading) {
    <div class="state state-loading">
      <mat-spinner diameter="32"></mat-spinner>
      <div>{{ 'DEAD_LETTERS.DETAIL.LOADING' | translate }}</div>
    </div>
  }

  @if (!detailLoading && detailError) {
    <div class="state state-error">
      <mat-icon>error_outline</mat-icon>
      <div>{{ 'DEAD_LETTERS.DETAIL.ERRORS.LOAD_FAILED' | translate }}</div>
      <button mat-stroked-button color="primary" type="button" (click)="retry()">
        {{ 'DEAD_LETTERS.ACTIONS.RETRY' | translate }}
      </button>
    </div>
  }

  @if (!detailLoading && !detailError && notFound) {
    <div class="state state-not-found">
      <mat-icon>search_off</mat-icon>
      <div>{{ 'DEAD_LETTERS.DETAIL.ERRORS.NOT_FOUND' | translate }}</div>
    </div>
  }

  @if (!detailLoading && !detailError && detail) {
    <div class="detail-shell">
      <!-- LEFT PANE (30%) -->
      <div class="pane-left">
        <!-- Event Summary / Overview -->
        <app-dead-letter-detail-overview
          [detail]="detail"
          [(expanded)]="overviewExpanded">
        </app-dead-letter-detail-overview>
        <!-- Delivery Diagnostics -->
        <app-dead-letter-diagnostics-section
          [detail]="detail"
          [(expanded)]="diagnosticsExpanded">
        </app-dead-letter-diagnostics-section>
        <!-- Company Information -->
        @if (detail.enrichment?.company) {
          <app-dead-letter-company-section
            [company]="detail.enrichment.company"
            [companyCompare]="companyCompare"
            [(expanded)]="companyExpanded"
            [showChangeIndicator]="compareService.hasChanges(companyCompare)">
          </app-dead-letter-company-section>
        }
        <!-- Treatment Group Info -->
        @if (detail.enrichment?.treatmentGroup) {
          <app-dead-letter-treatment-group-section
            [treatmentGroupCompare]="treatmentGroupCompare"
            [(expanded)]="treatmentGroupExpanded"
            [showChangeIndicator]="compareService.hasChanges(treatmentGroupCompare)">
          </app-dead-letter-treatment-group-section>
        }
      </div>
      <!-- RIGHT PANE (70%) -->
      <div class="pane-right">
        <mat-tab-group
          class="workspace-tabs"
          animationDuration="0ms">
          <!-- Logs tab (default) -->
          <mat-tab [label]="'DEAD_LETTERS.DETAIL.SECTIONS.LOGS' | translate">
            <div class="workspace-panel">
              <app-dead-letter-log-section
                [logsEntries]="logsEntries"
                [logsLoading]="logsLoading"
                [logsError]="logsError">
              </app-dead-letter-log-section>
            </div>
          </mat-tab>
          <!-- Raw JSON tab -->
          <mat-tab [label]="'DEAD_LETTERS.DETAIL.SECTIONS.RAW_JSON' | translate">
            <div class="workspace-panel">
              <pre class="diagnostic-content diagnostic-content-json" [innerHTML]="rawJson | jsonHighlight"></pre>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  }
</div>
